import { render, staticRenderFns } from "./PlantType.vue?vue&type=template&id=5d5e49d0&scoped=true&"
import script from "./PlantType.vue?vue&type=script&lang=ts&"
export * from "./PlantType.vue?vue&type=script&lang=ts&"
import style0 from "./PlantType.vue?vue&type=style&index=0&id=5d5e49d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5e49d0",
  null
  
)

export default component.exports